import { LabelChipsProps } from './types';

export const useLabelChips = (props: LabelChipsProps) => {
  const { labels, onRemove } = props;

  const handleChipDelete = (labelId: string) => {
    onRemove(labelId);
  };

  return {
    formattedLabels: labels,
    handleChipDelete,
  };
};
